var _circle, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTopCategory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#C3E1E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.5333 23.3999H16.8667C15.8357 23.3999 15 24.2356 15 25.2666C15 26.2975 15.8357 27.1333 16.8667 27.1333H35.5333C36.5643 27.1333 37.4 26.2975 37.4 25.2666C37.4 24.2356 36.5643 23.3999 35.5333 23.3999Z",
    fill: "#2AB9DB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5333 15.9333H16.8667C15.8357 15.9333 15 16.7691 15 17.8C15 18.831 15.8357 19.6667 16.8667 19.6667H35.5333C36.5643 19.6667 37.4 18.831 37.4 17.8C37.4 16.7691 36.5643 15.9333 35.5333 15.9333Z",
    fill: "#2AB9DB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0667 30.8667H16.8667C15.8357 30.8667 15 31.7024 15 32.7334C15 33.7643 15.8357 34.6001 16.8667 34.6001H28.0667C29.0976 34.6001 29.9334 33.7643 29.9334 32.7334C29.9334 31.7024 29.0976 30.8667 28.0667 30.8667Z",
    fill: "#2AB9DB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1569 31.727C33.6237 31.407 32.9453 31.7911 32.9453 32.413V41.6538C32.9453 42.2756 33.6237 42.6597 34.1569 42.3397L41.8576 37.7193C42.3755 37.4086 42.3755 36.6581 41.8576 36.3474L34.1569 31.727Z",
    fill: "#2AB9DB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopCategory);
export default __webpack_public_path__ + "static/media/top_category.cd2a98bff83103a06eb8db4f3bd40528.svg";
export { ForwardRef as ReactComponent };